// extracted by mini-css-extract-plugin
module.exports = {"bodyreset":"resets-module--bodyreset--1k_0Z"};